/* eslint-disable complexity */
// Models
import User from '../models/user';
import Roles from '../models/roles';
import EntityList from '../models/entityList';
import UserMaker from '../models/userMaker';

import {
    FETCH_USER_REQUEST,
    FETCH_USER_SUCCESS,
    FETCH_USER_ERROR,
    HIDE_USER_LOADER,
    SHOW_USER_LOADER,
    CREATE_USER_REQUEST,
    CREATE_USER_SUCCESS,
    CREATE_USER_ERROR,
    CREATE_USER_RESET,
    UPDATE_USER_RESET,
    GET_USER_ROLES_SUCCESS,
    GET_USER_ROLES_ERROR,
    FETCH_ENTITY_LIST_REQUEST,
    FETCH_ENTITY_LIST_SUCCESS,
    FETCH_ENTITY_LIST_ERROR,
    UPDATE_USER_REQUEST,
    UPDATE_USER_SUCCESS,
    UPDATE_USER_ERROR,
    CREATE_ADMIN_USER_REQUEST,
    CREATE_ADMIN_USER_SUCCESS,
    CREATE_ADMIN_USER_ERROR,
    UPDATE_ADMIN_USER_REQUEST,
    UPDATE_ADMIN_USER_SUCCESS,
    UPDATE_ADMIN_USER_ERROR,
    FETCH_USER_MAKERS_SUCCESS,
    FETCH_USER_MAKERS_ERROR,
    FETCH_SYSTEM_USERS_SUCCESS,
    FETCH_SYSTEM_USERS_REQUEST,
    FETCH_SYSTEM_USERS_ERROR,
} from './userManagement.constants';
import UserList from '../models/UserList';

export const initialState = {
    tableData: [],
    makerData: [],
    makerPagination: {},
    pagination: {},
    error: {},
    isLoading: false,
    createUser: {
        isSuccess: false,
        message: '',
        isLoading: false,
        data: {},
    },
    updateUser: {
        isSuccess: false,
        message: '',
        isLoading: false,
        data: {},
    },
    entityList: [],
    systemUserList: [],
    userRoles: { list: [] },
};

export const userManagementReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_USER_REQUEST:
            return { ...state, error: {} };
        case FETCH_USER_SUCCESS: {
            const createUserData = new User(action.payload);
            return {
                ...state,
                ...createUserData,
                error: {},
                updateUser: { message: '', isLoading: false, isSuccess: false },
                createUser: { message: '', isLoading: false, isSuccess: false },
            };
        }
        case SHOW_USER_LOADER:
            return { ...state, isLoading: true };
        case HIDE_USER_LOADER:
            return { ...state, isLoading: false };
        case FETCH_USER_ERROR:
            return { ...initialState, ...action.payload };
        case CREATE_USER_REQUEST:
            return {
                ...state,
                createUser: { ...action.payload, isLoading: true },
            };
        case CREATE_USER_SUCCESS:
            return {
                ...state,
                error: {},
                createUser: {
                    ...action.payload,
                    isLoading: false,
                    isSuccess: true,
                },
            };
        case CREATE_USER_ERROR:
            return {
                ...state,
                createUser: {
                    ...action.payload,
                    isLoading: false,
                    isSuccess: false,
                },
            };
        case CREATE_ADMIN_USER_REQUEST:
            return {
                ...state,
                createUser: { ...action.payload, isLoading: true },
            };
        case CREATE_ADMIN_USER_SUCCESS:
            return {
                ...state,
                createUser: {
                    ...action.payload,
                    isLoading: false,
                    isSuccess: true,
                },
            };
        case CREATE_ADMIN_USER_ERROR:
            return {
                ...state,
                createUser: {
                    ...action.payload,
                    isLoading: false,
                    isSuccess: false,
                },
            };

        case FETCH_USER_MAKERS_SUCCESS:
            const makersList = new UserMaker(action.payload);
            return {
                ...state,
                error: {},
                ...makersList,
            };
        case FETCH_USER_MAKERS_ERROR:
            return {
                ...state,
                ...action.payload,
            };
        case CREATE_USER_RESET:
            return {
                ...state,
                createUser: {
                    isSuccess: false,
                    message: '',
                    isLoading: false,
                    data: {},
                },
            };
        case UPDATE_USER_RESET:
            return {
                ...state,
                updateUser: {
                    isSuccess: false,
                    message: '',
                    isLoading: false,
                    data: {},
                },
            };
        case GET_USER_ROLES_SUCCESS: {
            const roles = new Roles(action.payload);
            return { ...state, userRoles: roles };
        }
        case GET_USER_ROLES_ERROR: {
            const message = action.payload.error;
            return { ...state, createUser: { message } };
        }
        case FETCH_ENTITY_LIST_REQUEST:
            return { ...state, createUser: { message: '', isLoading: true } };
        case FETCH_ENTITY_LIST_SUCCESS: {
            const entity = new EntityList(action.payload);
            return { ...state, entityList: entity.list };
        }
        case FETCH_SYSTEM_USERS_SUCCESS: {
            const userOptions = new UserList(action.payload);
            return { ...state, systemUserList: userOptions.list };
        }
        case FETCH_SYSTEM_USERS_REQUEST: {
            return { ...state, systemUserList: [] };
        }
        case FETCH_SYSTEM_USERS_ERROR: {
            return { ...state, systemUserList: [] };
        }
        case FETCH_ENTITY_LIST_ERROR: {
            const message = action.payload.error;
            return {
                ...state,
                createUser: { message, isLoading: false },
                updateUser: {
                    message,
                    isLoading: false,
                    isSuccess: false,
                },
            };
        }
        case UPDATE_USER_REQUEST:
            return {
                ...state,
                updateUser: { message: '', isLoading: true, isSuccess: false },
            };
        case UPDATE_USER_SUCCESS:
            return {
                ...state,
                updateUser: {
                    ...action.payload,
                    isLoading: false,
                    isSuccess: true,
                },
            };
        case UPDATE_USER_ERROR:
            return {
                ...state,
                updateUser: {
                    ...action.payload,
                    isLoading: false,
                    isSuccess: false,
                },
            };
        case UPDATE_ADMIN_USER_REQUEST:
            return {
                ...state,
                updateUser: { message: '', isLoading: true, isSuccess: false },
            };
        case UPDATE_ADMIN_USER_SUCCESS:
            return {
                ...state,
                updateUser: {
                    ...action.payload,
                    isLoading: false,
                    isSuccess: true,
                },
            };
        case UPDATE_ADMIN_USER_ERROR:
            return {
                ...state,
                updateUser: {
                    ...action.payload,
                    isLoading: false,
                    isSuccess: false,
                },
            };
        default:
            return state;
    }
};
